export default "fn map(pos: vec3<f32>) -> vec4<f32> {\n    return vec4<f32>(0, 0, 0, 100);\n}\n";